import React from 'react';
import { useTranslation } from '~/dependencies';
import { NewSession } from '~/components/ActiveCall/types';
import { IconTag } from '~/assets/svgIcons';
import { ReactSVG } from './styles';

type TagsButtonProps = {
  onClick: (session: NewSession) => void;
  session: NewSession;
};

const Tags = ({ onClick, session }: TagsButtonProps) => {
  const {
    answered,
    callActions: { tags: isTagsOpened },
  } = session;

  const { t } = useTranslation();

  function clickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    onClick(session);
  }

  return (
    <button
      type="button"
      title={t('components.activeCalls.btn.tags')}
      disabled={!answered}
      onClick={clickHandler}>
      <ReactSVG src={IconTag} selected={isTagsOpened} />
    </button>
  );
};

export default Tags;
